import {
  GetPendingInvitationsForOfficeResponse,
  getPendingInvitationsForOfficeResponseSchema,
} from '@omecare/utils';
import { UseQueryResult, useQuery } from '@tanstack/react-query';
import { z } from 'zod';
import http from '@/utils/http.service';

export const pendingInvitationsByOfficeQueryKey = (officeId: string) => [
  'pending-invitations-by-office',
  officeId,
];

export type PendingInvitationsByOfficeItem = z.infer<
  typeof getPendingInvitationsForOfficeResponseSchema
>['data'][number];

const getPendingInvitationsByOffice =
  (officeId: string) =>
  async (): Promise<GetPendingInvitationsForOfficeResponse> => {
    return http.offices.getPendingInvitations(officeId);
  };

export const useGetPendingInvitationsByOffice = (
  officeId: string,
): UseQueryResult<GetPendingInvitationsForOfficeResponse, Error> => {
  return useQuery({
    enabled: Boolean(officeId),
    queryFn: getPendingInvitationsByOffice(officeId),
    queryKey: pendingInvitationsByOfficeQueryKey(officeId),
    retry: false,
  });
};
